export function readPropertySearchParams(searchParams) {
  return {
    location: searchParams.get('location') || '',
    maxPrice: searchParams.get('max_price') || '',
    minSurface: searchParams.get('min_surface') || '',
    minBedrooms: searchParams.get('min_bedrooms') || searchParams.get('bedrooms') || '',
    propertyType: searchParams.get('property_type') || searchParams.get('type') || '',
  };
}

export function buildPropertyQueryParams({
  listingType,
  location,
  maxPrice,
  minSurface,
  minBedrooms,
  propertyType,
  budgetRange,
}) {
  const params = new URLSearchParams();
  if (listingType) params.append('listing_type', listingType);
  if (location) params.append('location', location);
  if (propertyType) params.append('property_type', propertyType);
  if (minBedrooms) params.append('min_bedrooms', minBedrooms);
  if (minSurface) params.append('min_surface', minSurface);

  if (budgetRange) {
    const [min, max] = budgetRange.split('-');
    if (min) params.append('min_price', min);
    if (max) params.append('max_price', max);
  } else if (maxPrice) {
    params.append('max_price', maxPrice);
  }

  return params;
}
